import Vue from "vue";
import Loading from "./main.vue";
import LoadingApi from "./api";
// import DirectiveFactory from './directive'

let api = LoadingApi(Vue);
Vue.$loading = api;
Vue.prototype.$loading = api;

Vue.component(Loading.name, Loading);